import React, { useRef, useEffect } from "react";
import { PersonaChip } from "../personas/PersonaChip";

interface PersonaChipsProps {
  linkRecordId: string;
  personas: any[];
  personaLinkRecords: any;
  onAddPersona: (personaId: string) => void;
  onRemovePersona: (personaId: string) => void;
  onToggleOrientation: (personaId: string) => void;
  showSelector: boolean;
  onShowSelector: () => void;
}

export const PersonaChips: React.FC<PersonaChipsProps> = ({
  linkRecordId,
  personas,
  personaLinkRecords,
  onAddPersona,
  onRemovePersona,
  onToggleOrientation,
  showSelector,
  onShowSelector,
}) => {
  const selectorRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: PointerEvent) => {
      if (
        showSelector &&
        selectorRef.current &&
        !selectorRef.current.contains(event.target as Node)
      ) {
        setTimeout(() => {
          onShowSelector();
        }, 0);
      }
    };

    document.addEventListener("pointerdown", handleClickOutside, true);
    return () => {
      document.removeEventListener("pointerdown", handleClickOutside, true);
    };
  }, [showSelector, onShowSelector]);

  const filteredPersonas = personas.filter(
    (p) =>
      !personaLinkRecords[linkRecordId]?.some(
        (plr: any) => plr.personaId === p.id
      )
  );

  return (
    <div className="collection-resources-personas">
      {personaLinkRecords[linkRecordId]?.map((plr: any) => {
        const persona = personas.find((p) => p.id === plr.personaId);
        if (!persona) return null;

        return (
          <PersonaChip
            key={plr.personaId}
            personaName={persona.name}
            orientation={plr.orientation}
            onDelete={() => onRemovePersona(plr.personaId)}
            onToggleOrientation={() => onToggleOrientation(plr.personaId)}
          />
        );
      })}

      {filteredPersonas.length > 0 && (
        <div
          className="collection-resources-add-persona"
          onClick={onShowSelector}>
          +
        </div>
      )}

      {filteredPersonas.length > 0 && showSelector && (
        <div
          ref={selectorRef}
          className="collection-resources-persona-selector">
          {filteredPersonas.map((persona) => (
            <div
              key={persona.id}
              className="collection-resources-persona-option"
              onClick={() => onAddPersona(persona.id)}>
              {persona.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
